import {Slice, SliceCaseReducers} from '@reduxjs/toolkit';
import {SliceContext} from 'plugins/context/Slice/SliceContext';
import {useContext} from 'react';

export const useSlice = <T, A extends SliceCaseReducers<T> = SliceCaseReducers<T>>() => {
    const {slice} = useContext(SliceContext);

    return slice as Slice<T, A>;
};
